import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDrawingDocument = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.7 4C4.21953 4 3 5.21953 3 6.7V17.5C3 18.9805 4.21953 20.2 5.7 20.2H21V5.8H8.4V4H5.7ZM5.7 5.8H6.6V14.8H5.7C5.35049 14.8 5.10781 15.0511 4.8 15.1744V6.7C4.8 6.19147 5.19147 5.8 5.7 5.8ZM8.4 7.6H19.2V18.4H5.7C5.19147 18.4 4.8 18.0085 4.8 17.5C4.8 16.9915 5.19147 16.6 5.7 16.6H8.4V7.6ZM10.2 9.4V16.6H17.4V9.4H14.7V11.2H15.6V14.8H14.7V13H12.9V14.8H12V11.2H12.9V9.4H10.2Z",
		fill: "currentColor"
	})
});
export default SvgDrawingDocument;
